module.exports = __webpack_public_path__ + "img/cars@450w.5f6fae17.webp";